import { Model, ModelAttributes, collection, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingAppeal from "./FundingAppeal";
import FundingScoutProspect from "./FundingScoutProspect";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    completed_at: {
      type: "datetime",
    },
    created_at: {
      type: "datetime",
    },
    error_message: {
      type: "string",
    },
    funding_appeal_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    progress_json: {
      type: "json",
      jsonType: null,
    },
    progress_message: {
      type: "string",
    },
    requested_by_account_user_id: {
      type: "string",
    },
    search_brief: {
      type: "string",
    },
    started_at: {
      type: "datetime",
    },
    status: {
      type: "enum",
      enumType: "running" as Database["public"]["Enums"]["funding_scout_run_status"],
    },
    summary: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {
    prospects: collection(() => FundingScoutProspect as any, "funding_scout_run_id"),
  },
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    funding_appeal: reference(() => FundingAppeal as any, "funding_appeal_id"),
    requested_by_account_user: reference(() => AccountUser as any, "requested_by_account_user_id"),
  },
);

interface FundingScoutRun extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_scout_runs", config)
class FundingScoutRun extends Model<typeof config> {}

export default FundingScoutRun;
